import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-codir',
  imports: [],
  templateUrl: './codir.component.html',
  styleUrl: './codir.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CodirComponent {

}
